"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _conferenceService, _alias, _conferenceId, _ownerId, _own, _options, _participants, _forwardedParticipants, _maxVideoForwarding, _localStateMute, _isLeaving, _listenOnly, _statsBuffer, _masterStatus, _processCallback, _remoteOffers, _rtc, _sharedStreams, _sdpQueue;
Object.defineProperty(exports, "__esModule", { value: true });
const VoxeetRTCShim_1 = require("../../lib/adapter/VoxeetRTCShim");
const VoxeetRTC_1 = __importDefault(require("../../lib/adapter/VoxeetRTC"));
const VoxeetRTCElectron_1 = __importDefault(require("../../lib/adapter/VoxeetRTCElectron"));
const VoxeetRTCDolbyVoice_1 = __importDefault(require("../../lib/adapter/VoxeetRTCDolbyVoice"));
const Participant_1 = require("../../models/Participant");
const events_1 = require("../../events");
const EventBusInstance_1 = __importDefault(require("../../events/EventBusInstance"));
const debug_1 = __importDefault(require("debug"));
const logging_1 = __importDefault(require("../../lib/logging"));
const Helpers_1 = require("../../models/Helpers");
const Exceptions_1 = require("../../lib/Exceptions");
const Utils_1 = require("../../lib/Utils");
const VoxeetApi_1 = __importDefault(require("../../api/VoxeetApi"));
const index_1 = require("../../events/conference/index");
const AsyncCallQueue_1 = __importDefault(require("../../utils/AsyncCallQueue"));
const ConferenceUtils_1 = require("../../utils/ConferenceUtils");
const VideoForwarding_1 = __importDefault(require("../../models/VideoForwarding"));
/**
 * @ignore
 */
const debug = debug_1.default('vxt:conference');
/**
 * @ignore
 */
const STATS_CYCLE = 30000;
/**
 * @ignore
 */
const STATS_INTERVAL = 5000;
/**
 * @ignore
 */
var QualityIndicators;
(function (QualityIndicators) {
    QualityIndicators[QualityIndicators["PSTN_QUALITY"] = 0] = "PSTN_QUALITY";
    QualityIndicators[QualityIndicators["ULTRA_LOW"] = 1] = "ULTRA_LOW";
    QualityIndicators[QualityIndicators["LOW"] = 1] = "LOW";
    QualityIndicators[QualityIndicators["MEDIUM"] = 2] = "MEDIUM";
    QualityIndicators[QualityIndicators["HIGH"] = 3] = "HIGH";
    QualityIndicators[QualityIndicators["ULTRA_HIGH"] = 3] = "ULTRA_HIGH";
})(QualityIndicators || (QualityIndicators = {}));
/**
 * @ignore
 */
class ConferenceManager {
    constructor(conferenceService) {
        _conferenceService.set(this, void 0);
        _alias.set(this, void 0);
        _conferenceId.set(this, void 0);
        _ownerId.set(this, void 0);
        _own.set(this, void 0);
        _options.set(this, void 0);
        _participants.set(this, new Map());
        _forwardedParticipants.set(this, new Map());
        _maxVideoForwarding.set(this, void 0);
        _localStateMute.set(this, void 0);
        _isLeaving.set(this, void 0);
        _listenOnly.set(this, false);
        _statsBuffer.set(this, void 0);
        _masterStatus.set(this, void 0);
        _processCallback.set(this, void 0);
        _remoteOffers.set(this, void 0);
        _rtc.set(this, void 0); // Temporary before adapter refactor to typescript
        _sharedStreams.set(this, new Array());
        _sdpQueue.set(this, void 0);
        __classPrivateFieldSet(this, _conferenceService, conferenceService);
    }
    get rtc() {
        return __classPrivateFieldGet(this, _rtc);
    }
    set rtc(value) {
        __classPrivateFieldSet(this, _rtc, value);
    }
    get isLeaving() {
        return __classPrivateFieldGet(this, _isLeaving);
    }
    get maxVideoForwarding() {
        return __classPrivateFieldGet(this, _maxVideoForwarding);
    }
    get participants() {
        return __classPrivateFieldGet(this, _participants);
    }
    get forwardedParticipants() {
        return __classPrivateFieldGet(this, _forwardedParticipants);
    }
    /**
     * @deprecated
     */
    get localStateMute() {
        return __classPrivateFieldGet(this, _localStateMute);
    }
    /**
     * @deprecated
     */
    setLocalStateMute(value) {
        __classPrivateFieldSet(this, _localStateMute, value);
    }
    getPeerConnectionStatus() {
        return __classPrivateFieldGet(this, _masterStatus);
    }
    isDvwc() {
        return __classPrivateFieldGet(this, _rtc) instanceof VoxeetRTCDolbyVoice_1.default;
    }
    isElectron() {
        return __classPrivateFieldGet(this, _rtc) instanceof VoxeetRTCElectron_1.default;
    }
    // attach session socket
    init(owner, alias, options, processCb = null, listenOnly = false, conference) {
        return __awaiter(this, void 0, void 0, function* () {
            this.clear();
            __classPrivateFieldSet(this, _alias, alias);
            __classPrivateFieldSet(this, _ownerId, owner.id);
            __classPrivateFieldSet(this, _own, owner);
            __classPrivateFieldSet(this, _options, options);
            __classPrivateFieldSet(this, _processCallback, processCb);
            __classPrivateFieldSet(this, _listenOnly, listenOnly);
            if (__classPrivateFieldGet(this, _options).mixing.enabled) {
                // Forcing listen only in mixing mode
                __classPrivateFieldSet(this, _listenOnly, true);
            }
            let conferenceInfo;
            try {
                try {
                    conferenceInfo = yield this.onInitialized(conference);
                }
                catch (e) {
                    ConferenceUtils_1.createConferenceError(e);
                }
                if (__classPrivateFieldGet(this, _options).videoFilter) {
                    const data = {
                        filter: __classPrivateFieldGet(this, _options).videoFilter,
                        filterOptions: Object.assign({}, __classPrivateFieldGet(this, _options).videoFilterOptions),
                    };
                    EventBusInstance_1.default.send(events_1.Events.ConferenceVideoFilterUpdate.fromData(data));
                }
                return conferenceInfo;
            }
            catch (e) {
                EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(e));
                this.releaseRtc();
                if (__classPrivateFieldGet(this, _sdpQueue)) {
                    __classPrivateFieldGet(this, _sdpQueue).stop();
                }
                __classPrivateFieldSet(this, _sdpQueue, null);
                throw e;
            }
        });
    }
    clear() {
        if (__classPrivateFieldGet(this, _sdpQueue)) {
            __classPrivateFieldGet(this, _sdpQueue).stop();
        }
        __classPrivateFieldSet(this, _sdpQueue, null);
        __classPrivateFieldSet(this, _conferenceId, null);
        __classPrivateFieldSet(this, _isLeaving, false);
        __classPrivateFieldSet(this, _ownerId, null);
        __classPrivateFieldSet(this, _statsBuffer, []);
        // Master peer connection status back up
        __classPrivateFieldSet(this, _masterStatus, '');
        __classPrivateFieldSet(this, _participants, new Map());
        __classPrivateFieldSet(this, _forwardedParticipants, new Map());
        __classPrivateFieldSet(this, _statsBuffer, []);
        __classPrivateFieldSet(this, _rtc, null);
    }
    videoForwarding(max, participants) {
        let participantsFormat = [];
        if (participants) {
            // Format JSON for backend endpoint
            participants.forEach((participant, key) => {
                participantsFormat.push(new VideoForwarding_1.default(participant.id, 0));
            });
        }
        return VoxeetApi_1.default.conferences
            .videoForwarding({
            conferenceId: __classPrivateFieldGet(this, _conferenceId),
            data: {
                forwardingStrategy: { type: 'lastSpeakerStrategy', params: { maxActiveStreams: max } },
                forwardingVideoList: participantsFormat,
            },
        })
            .then(() => {
            __classPrivateFieldSet(this, _maxVideoForwarding, max);
        })
            .catch((e) => {
            throw new Exceptions_1.VideoForwardingError(e.message);
        });
    }
    updatePermissions(participantPermissions) {
        return VoxeetApi_1.default.conferences.updatePermissions({
            conferenceId: __classPrivateFieldGet(this, _conferenceId),
            data: {
                userPermissions: participantPermissions.map((p) => ({
                    newPermissions: p.permissions,
                    userId: p.participant.id,
                })),
            },
        });
    }
    initRtc(constraints, processCb = null, listenOnly = false, ownerId, options, mixing, alias, dvwc) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = { constraints, processCb, listenOnly, ownerId, options, mixing, alias, dvwc };
            if (VoxeetRTCShim_1.electronManager.isAvailable()) {
                __classPrivateFieldSet(this, _rtc, new VoxeetRTCElectron_1.default());
                this.registerRtcEvents();
                // (<any>electronManager).on('leave', () => {
                //   this.leave({ leaveRoom: false });
                // });
                yield __classPrivateFieldGet(this, _rtc).init(config);
            }
            else if (dvwc) {
                try {
                    __classPrivateFieldSet(this, _rtc, new VoxeetRTCDolbyVoice_1.default());
                    this.registerRtcEvents();
                    yield __classPrivateFieldGet(this, _rtc).init(config);
                }
                catch (e) {
                    logging_1.default.warn('Falling back to Opus');
                    EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(Exceptions_1.DolbyVoiceNotSupported(e.message)));
                    __classPrivateFieldSet(this, _rtc, VoxeetRTC_1.default.create({ audio3D: false /*this.audio3D*/ }));
                    yield __classPrivateFieldGet(this, _rtc).init(config);
                }
            }
            else {
                __classPrivateFieldSet(this, _rtc, VoxeetRTC_1.default.create({ audio3D: false /*this.audio3D*/ }));
                this.registerRtcEvents();
                yield __classPrivateFieldGet(this, _rtc).init(config);
            }
        });
    }
    registerRtcEvents() {
        __classPrivateFieldGet(this, _rtc).on('sessionCreated', this.onSessionCreated.bind(this));
        __classPrivateFieldGet(this, _rtc).on('sessionEnded', this.onRtcSessionEnded.bind(this));
        __classPrivateFieldGet(this, _rtc).on('error', this.onRtcError.bind(this));
        __classPrivateFieldGet(this, _rtc).on('autoplayBlocked', this.onAutoplayBlocked.bind(this));
        __classPrivateFieldGet(this, _rtc).on('addStream', this.onStreamAdded.bind(this));
        __classPrivateFieldGet(this, _rtc).on('updateStream', this.onStreamUpdated.bind(this));
        __classPrivateFieldGet(this, _rtc).on('removeStream', this.onStreamRemoved.bind(this));
        __classPrivateFieldGet(this, _rtc).on('addScreenStream', this.onScreenStreamAdded.bind(this));
        __classPrivateFieldGet(this, _rtc).on('removeScreenStream', this.onScreenStreamRemoved.bind(this));
        __classPrivateFieldGet(this, _rtc).on('updateScreenStream', this.onScreenStreamUpdated.bind(this));
        __classPrivateFieldGet(this, _rtc).on('endedScreenStream', this.onScreenStreamEnded.bind(this));
        __classPrivateFieldGet(this, _rtc).on('connectionStatus', this.onPeerConnectionStatus.bind(this));
        __classPrivateFieldGet(this, _rtc).on('iceCandidatesGatheringComplete', this.onIceCandidatesGatheringComplete.bind(this));
    }
    onInitialized(conference) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            logging_1.default.trace('Conference.onInitialized');
            let joinOptions = Object.assign({}, __classPrivateFieldGet(this, _options));
            if (__classPrivateFieldGet(this, _options).dvwc) {
                joinOptions.dvwc = true;
            }
            this.participants.set(__classPrivateFieldGet(this, _ownerId), __classPrivateFieldGet(this, _own));
            //eventBus.send(ParticipantAdded.fromData(<ParticipantAddedData>this.#));
            const joinData = {
                conferenceId: __classPrivateFieldGet(this, _alias),
                data: {
                    sync: true,
                    device_type: 'web',
                    sdp_version: VoxeetRTC_1.default.sdpVersion(),
                    user: {
                        type: __classPrivateFieldGet(this, _listenOnly) ? 'listener' : 'user',
                    },
                    options: Object.assign({}, joinOptions),
                },
            };
            if (__classPrivateFieldGet(this, _options).hasOwnProperty('maxVideoForwarding')) {
                __classPrivateFieldSet(this, _maxVideoForwarding, __classPrivateFieldGet(this, _options).maxVideoForwarding);
            }
            if (__classPrivateFieldGet(this, _options).mixing.enabled) {
                joinData.data.user.type = 'mixer';
            }
            try {
                const { data } = yield VoxeetApi_1.default.conferences.joinRoom(joinData);
                debug('JoinConference:', data);
                __classPrivateFieldSet(this, _conferenceId, data.conferenceId);
                //Remove video from constraints if joining audio only conference
                if (((_a = data === null || data === void 0 ? void 0 : data.metadata) === null || _a === void 0 ? void 0 : _a.videoCodec) === 'NONE') {
                    __classPrivateFieldGet(this, _options).constraints.video = false;
                }
                yield this.initRtc(__classPrivateFieldGet(this, _options).constraints, __classPrivateFieldGet(this, _processCallback), __classPrivateFieldGet(this, _listenOnly), __classPrivateFieldGet(this, _ownerId), __classPrivateFieldGet(this, _options), __classPrivateFieldGet(this, _options).mixing, __classPrivateFieldGet(this, _alias), VoxeetRTC_1.default.createDvwcOptions(__classPrivateFieldGet(this, _options).dvwc, {
                    enabled: data.wasmCandidates && data.wasmDescription,
                }));
                __classPrivateFieldSet(this, _sdpQueue, new AsyncCallQueue_1.default(__classPrivateFieldGet(this, _rtc).isPeerConnectionStable.bind(__classPrivateFieldGet(this, _rtc))));
                __classPrivateFieldGet(this, _sdpQueue).start();
                const conferenceInfo = {
                    conferenceId: data.conferenceId,
                    conferenceAlias: data.conferenceAlias,
                    conferenceType: data.conferenceType,
                    conferencePincode: data.conferencePincode,
                    metadata: data.metadata,
                    recordingStatus: data.recordingStatus,
                    recordingUser: data.recordingUser,
                    startRecordTimestamp: data.startRecordTimestamp,
                };
                EventBusInstance_1.default.send(events_1.Events.ConferenceJoined.fromData(conferenceInfo));
                if (data.participants) {
                    data.participants.map((p) => {
                        //this.participants[p.userId] = { name: p.name, externalId: p.externalId, avatarUrl: p.avatarUrl };
                        p.user_id = p.participant_id;
                        EventBusInstance_1.default.send(index_1.ParticipantAdded.fromData(p));
                    });
                }
                if (__classPrivateFieldGet(this, _maxVideoForwarding) === undefined && Helpers_1.isMobile()) {
                    //TODO: This logic can be simplified when backend will return correct value for mobiles.
                    __classPrivateFieldSet(this, _maxVideoForwarding, Utils_1.VIDEO_FORWARDING_MOBILE_MAX_VALUE);
                }
                else if (data.hasOwnProperty('vfs')) {
                    __classPrivateFieldSet(this, _maxVideoForwarding, data.vfs.defaultMaxVideoForwarded);
                }
                conference.params = data.metadata;
                if (data.description || data.wasmDescription) {
                    const config = {
                        peerId: __classPrivateFieldGet(this, _ownerId),
                        description: data.description,
                        candidates: data.candidates,
                        wasmDescription: data.wasmDescription,
                        wasmCandidates: data.wasmCandidates,
                        isMaster: true,
                    };
                    yield __classPrivateFieldGet(this, _rtc).addPeer(config); // only one out of queue
                }
                // Timer to check if the master peer connection has stayed on status checking for more than 40s
                setTimeout(() => {
                    if (__classPrivateFieldGet(this, _masterStatus) === 'checking') {
                        // Peer connection is screwed
                        EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(Exceptions_1.PeerConnectionFailedError(__classPrivateFieldGet(this, _ownerId))));
                    }
                }, 25000);
                return conferenceInfo;
            }
            catch (e) {
                __classPrivateFieldSet(this, _conferenceId, null);
                logging_1.default.error('webrtc', 'Failed to join conference', e);
                EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(e));
                throw e;
            }
        });
    }
    onSessionCreated(peerId, sessionDescription, candidates, ssMsid, state, oid, wasm) {
        debug('Conference.onSessionCreated', peerId, sessionDescription, oid, wasm);
        VoxeetApi_1.default.conferences
            .answer({
            conferenceId: __classPrivateFieldGet(this, _conferenceId),
            peerId: peerId,
            data: {
                oid,
                sdp: sessionDescription.sdp,
                candidates,
                ssMsid,
                state,
                wasm,
            },
        })
            .then((response) => {
            logging_1.default.debug(response);
        })
            .catch((error) => {
            logging_1.default.error('webrtc', error);
            EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(error));
        });
    }
    onRtcSessionEnded(stateDump) {
        EventBusInstance_1.default.send(events_1.Events.ConferenceLeft.fromData(stateDump));
    }
    onRtcError(error) {
        EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(error));
    }
    onIceCandidatesGatheringComplete(peerId, candidates) {
        logging_1.default.trace('Conference.onIceCandidatesGatheringComplete', peerId, candidates);
        VoxeetApi_1.default.conferences
            .candidates({
            conferenceId: __classPrivateFieldGet(this, _conferenceId),
            peerId: peerId,
            data: {
                commandType: 'CandidatesGatheredCommand',
                candidates: candidates,
            },
        })
            .then((r) => {
            logging_1.default.debug(r);
        })
            .catch((error) => {
            logging_1.default.error('webrtc', error);
            EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(error));
        });
    }
    onPeerConnectionStatus(status) {
        if (__classPrivateFieldGet(this, _conferenceService)) {
            if (status.peerId === __classPrivateFieldGet(this, _ownerId)) {
                __classPrivateFieldSet(this, _masterStatus, status.connectionStatus);
            }
            //this.conferenceService.peerStatusUpdated(status.peerId, status); //TODO
            if (status.connectionStatus === 'failed') {
                EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(Exceptions_1.PeerConnectionFailedError(status.peerId)));
            }
            else if (status.connectionStatus === 'disconnected') {
                EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(Exceptions_1.PeerDisconnectedError(status.peerId)));
            }
        }
    }
    onRenegociationEnded(data) {
        if (__classPrivateFieldGet(this, _conferenceService)) {
            //this.conferenceService.renegociationEnded(); //TODO
        }
    }
    onAutoplayBlocked() {
        if (__classPrivateFieldGet(this, _conferenceService)) {
            __classPrivateFieldGet(this, _conferenceService).onAutoplayBlocked();
        }
    }
    onStreamAdded(peerId, stream) {
        EventBusInstance_1.default.send(events_1.Events.StreamAdded.fromData({ peerId: peerId, stream: stream }));
        if (__classPrivateFieldGet(this, _conferenceService)) {
            __classPrivateFieldGet(this, _conferenceService).onStreamAdded(peerId, stream);
        }
    }
    onStreamUpdated(peerId, stream) {
        EventBusInstance_1.default.send(events_1.Events.StreamUpdated.fromData({ peerId: peerId, stream: stream }));
        if (__classPrivateFieldGet(this, _conferenceService)) {
            __classPrivateFieldGet(this, _conferenceService).onStreamUpdated(peerId, stream);
        }
    }
    onStreamRemoved(peerId, stream) {
        EventBusInstance_1.default.send(events_1.Events.StreamRemoved.fromData({ peerId: peerId, stream: stream }));
        if (__classPrivateFieldGet(this, _conferenceService)) {
            __classPrivateFieldGet(this, _conferenceService).onStreamRemoved(peerId, stream);
        }
    }
    onScreenStreamAdded(peerId, stream) {
        if (__classPrivateFieldGet(this, _conferenceService)) {
            __classPrivateFieldGet(this, _conferenceService).onStreamAdded(peerId, stream);
        }
    }
    onScreenStreamRemoved(peerId, stream) {
        if (__classPrivateFieldGet(this, _conferenceService)) {
            __classPrivateFieldGet(this, _conferenceService).onStreamRemoved(peerId, stream);
        }
    }
    onScreenStreamUpdated(peerId, stream) {
        if (__classPrivateFieldGet(this, _conferenceService)) {
            __classPrivateFieldGet(this, _conferenceService).onStreamUpdated(peerId, stream);
        }
    }
    onScreenStreamEnded() {
        this.stopScreenShare();
    }
    // for a received Offer
    setRemoteOffer(data) {
        debug('setRemoteOffer', data);
        let user = __classPrivateFieldGet(this, _participants).get(data.userId);
        if (!user) {
            EventBusInstance_1.default.send(index_1.ParticipantAdded.fromData({
                user_id: data.userId,
            })); // Faking participant added in case of wrong reception order
        }
        if (__classPrivateFieldGet(this, _participants).get(data.userId) || data.userId === __classPrivateFieldGet(this, _ownerId)) {
            const config = {
                peerId: data.userId,
                description: data.description,
                candidates: data.candidates,
                isMaster: data.master,
                state: data.state,
            };
            __classPrivateFieldGet(this, _sdpQueue).push(__classPrivateFieldGet(this, _rtc), __classPrivateFieldGet(this, _rtc).addPeer, config).catch((error) => {
                EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(error));
            });
        }
        else {
            logging_1.default.error(Exceptions_1.ParticipantNotFoundError(data.userId));
        }
    }
    addParticipant(e) {
        debug('addUser', e);
        let user = __classPrivateFieldGet(this, _participants).get(e.userId);
        if (!user) {
            user = new Participant_1.Participant(e.userId, e.participantType);
            user.init(e);
            __classPrivateFieldGet(this, _participants).set(e.userId, user);
        }
        return user;
    }
    updateParticipant(data) {
        debug('updateUser', data);
        let user = __classPrivateFieldGet(this, _participants).get(data.userId);
        if (user) {
            // local participants do not receive their own audio
            data.audioReceivingStopped = data.audioReceivingStopped || data.userId === __classPrivateFieldGet(this, _ownerId);
            user.update(data);
            if (data.status === 'LEFT' || (data.status === 'INACTIVE' && data.userId !== __classPrivateFieldGet(this, _ownerId))) {
                __classPrivateFieldGet(this, _rtc).removePeer(data.userId);
            }
            else {
                if (this.isElectron()) {
                    // fix cases when using electron with dvc and a remote participant joins wih audio only
                    this.rtc.addFakePeer(data.userId);
                }
            }
            //this.conferenceService.participantStatusUpdated(participant.userId, participant.status);
        }
        else if (data.userId === __classPrivateFieldGet(this, _ownerId)) {
            //this.conferenceService.participantStatusUpdated(data.user_id, toParticipantStatus(data.status));
        }
        else {
            user = this.addParticipant(data);
        }
        return user;
    }
    participantSwitched(data) {
        debug('userSwitched');
        if (__classPrivateFieldGet(this, _rtc)) {
            // this.#rtc.removePeer(data.userId);
        }
    }
    onConferenceStats(data) {
        //console.log(data);
        /* if (data && data.participantStats && data.participantStats[this.#ownerId]) {
           let score = 0;
           if (data.participantStats[this.#ownerId][this.#ownerId] && data.participantStats[this.#ownerId][this.#ownerId].stats.length > 0) {
             score = data.participantStats[this.#ownerId][this.#ownerId].stats.map(s => s.score).reduce((a,b) => a + b) / parseFloat(data.participantStats[this.#ownerId][this.#ownerId].stats.length);
           }
    
           if (this.sdk) {
             this.sdk.qualityIndicators({
               mos: score
             });
           }
         }*/
    }
    /*onSpeakerChanged(data) {
      if (this.sdk) {
        this.sdk.speakerChanged(data.speakerId);
      }
    }
    */
    stopVideoLocally(peerId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.checkInitialized();
                __classPrivateFieldGet(this, _rtc).stopVideoForPeer(peerId);
            }
            catch (e) {
                logging_1.default.error(e);
                EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(e));
                throw e;
            }
        });
    }
    stopVideoForPeer(peerId) {
        return __awaiter(this, void 0, void 0, function* () {
            let oid = null;
            try {
                yield this.checkInitialized();
                __classPrivateFieldGet(this, _rtc).stopVideoForPeer(peerId);
                let r = yield VoxeetApi_1.default.conferences.stopMedia({
                    conferenceId: __classPrivateFieldGet(this, _conferenceId),
                    peerId: peerId,
                    data: { index: 0, label: 'camera', media: ['video'] },
                });
                if (peerId === __classPrivateFieldGet(this, _ownerId)) {
                    if (!r.data || !r.data.description) {
                        throw new Error('Empty server response for stop video');
                    }
                    let desc = r.data.description;
                    oid = desc.oid;
                    yield __classPrivateFieldGet(this, _sdpQueue).push(__classPrivateFieldGet(this, _rtc), __classPrivateFieldGet(this, _rtc).setRemoteSdp, __classPrivateFieldGet(this, _ownerId), desc, '');
                    __classPrivateFieldGet(this, _rtc).createAnswer(__classPrivateFieldGet(this, _ownerId), 'default', oid);
                }
            }
            catch (e) {
                logging_1.default.error(e);
                EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(e));
                throw e;
            }
        });
    }
    startVideoForPeer(peerId, constraints) {
        let oid = null;
        return this.checkInitialized()
            .then(() => VoxeetApi_1.default.conferences.startMedia({
            conferenceId: __classPrivateFieldGet(this, _conferenceId),
            peerId: peerId,
            data: { index: 0, label: 'camera', media: ['video'] },
        }))
            .then((r) => {
            if (peerId !== __classPrivateFieldGet(this, _ownerId))
                throw new Error('Remote participant');
            if (!r.data || !r.data.description) {
                throw new Error('Empty server response for start video');
            }
            oid = r.data.description.oid;
            return r.data.description;
        })
            .then((desc) => __classPrivateFieldGet(this, _sdpQueue).push(__classPrivateFieldGet(this, _rtc), __classPrivateFieldGet(this, _rtc).setRemoteSdp, __classPrivateFieldGet(this, _ownerId), desc, ''))
            .then(() => __classPrivateFieldGet(this, _rtc).startVideoForPeer(peerId, constraints))
            .then(() => __classPrivateFieldGet(this, _rtc).createAnswer(__classPrivateFieldGet(this, _ownerId), 'default', oid))
            .catch((e) => {
            if (e.message === 'Remote participant') {
                // promise chain aborted
            }
            else {
                if (oid)
                    __classPrivateFieldGet(this, _rtc).createAnswer(__classPrivateFieldGet(this, _ownerId), 'default', oid);
                logging_1.default.error(e);
                EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(e));
                throw e;
            }
        });
    }
    stopAudioForPeer(peerId) {
        let oid = null;
        return this.checkInitialized()
            .then(() => __classPrivateFieldGet(this, _rtc).stopAudioForPeer(peerId))
            .then(() => VoxeetApi_1.default.conferences.stopMedia({
            conferenceId: __classPrivateFieldGet(this, _conferenceId),
            peerId: peerId,
            data: { index: 0, label: 'camera', media: ['audio'] },
        }))
            .then((r) => {
            if (peerId !== __classPrivateFieldGet(this, _ownerId))
                throw new Error('Remote participant');
            if (!r.data || !r.data.description) {
                throw new Error('Empty server response for stop audio');
            }
            oid = r.data.description.oid;
            return r.data.description;
        })
            .then((desc) => __classPrivateFieldGet(this, _sdpQueue).push(__classPrivateFieldGet(this, _rtc), __classPrivateFieldGet(this, _rtc).setRemoteSdp, __classPrivateFieldGet(this, _ownerId), desc, ''))
            .then(() => __classPrivateFieldGet(this, _rtc).createAnswer(__classPrivateFieldGet(this, _ownerId), 'default', oid))
            .catch((e) => {
            if (e.message === 'Remote participant') {
                // promise chain aborted
            }
            else {
                EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(e));
                throw e;
            }
        });
    }
    startAudioForPeer(peerId) {
        let oid = null;
        return this.checkInitialized()
            .then(() => VoxeetApi_1.default.conferences.startMedia({
            conferenceId: __classPrivateFieldGet(this, _conferenceId),
            peerId: peerId,
            data: { index: 0, label: 'camera', media: ['audio'] },
        }))
            .then((r) => {
            if (peerId !== __classPrivateFieldGet(this, _ownerId))
                throw new Error('Remote participant');
            if (!r.data || !r.data.description) {
                throw new Error('Empty server response for start audio');
            }
            oid = r.data.description.oid;
            return r.data.description;
        })
            .then((desc) => __classPrivateFieldGet(this, _sdpQueue).push(__classPrivateFieldGet(this, _rtc), __classPrivateFieldGet(this, _rtc).setRemoteSdp, __classPrivateFieldGet(this, _ownerId), desc, ''))
            .then(() => __classPrivateFieldGet(this, _rtc).startAudioForPeer(peerId))
            .then(() => __classPrivateFieldGet(this, _rtc).createAnswer(__classPrivateFieldGet(this, _ownerId), 'default', oid))
            .catch((e) => {
            if (e.message === 'Remote participant') {
                // promise chain aborted
            }
            else {
                if (oid)
                    __classPrivateFieldGet(this, _rtc).createAnswer(__classPrivateFieldGet(this, _ownerId), 'default', oid);
                logging_1.default.error(e);
                EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(e));
                throw e;
            }
        });
    }
    startStream(stream, type) {
        const media = new Array();
        const pc = __classPrivateFieldGet(this, _rtc).peers.find((p) => p.isMaster);
        let oid = null;
        if (stream.getAudioTracks().length > 0) {
            media.push('audio');
        }
        if (stream.getVideoTracks().length > 0) {
            media.push('video');
        }
        return this.checkInitialized()
            .then(() => VoxeetApi_1.default.conferences.startMedia({
            conferenceId: __classPrivateFieldGet(this, _conferenceId),
            peerId: __classPrivateFieldGet(this, _ownerId),
            data: { index: 2, label: 'custom', media: media },
        }))
            .then((r) => {
            if (!r.data || !r.data.description) {
                throw new Error('Empty server response for start audio');
            }
            oid = r.data.description.oid;
            return r.data.description;
        })
            .then((desc) => __classPrivateFieldGet(this, _sdpQueue).push(__classPrivateFieldGet(this, _rtc), __classPrivateFieldGet(this, _rtc).setRemoteSdp, __classPrivateFieldGet(this, _ownerId), desc, ''))
            .then(() => __classPrivateFieldGet(this, _rtc).addStream(stream, pc.connection, 2))
            .then(() => __classPrivateFieldGet(this, _rtc).createAnswer(__classPrivateFieldGet(this, _ownerId), 'default', oid))
            .catch((e) => {
            logging_1.default.error(e);
            EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(e));
            throw e;
        });
    }
    stopStream(stream) { }
    selectAudioInput(deviceId) {
        return this.checkInitialized()
            .then(() => __classPrivateFieldGet(this, _rtc).selectAudioInput(deviceId))
            .catch((e) => {
            EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(e));
            throw e;
        });
    }
    selectVideoInput(deviceId, constraints) {
        return this.checkInitialized()
            .then(() => __classPrivateFieldGet(this, _rtc).selectVideoInput(deviceId, constraints))
            .catch((e) => {
            EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(e));
            throw e;
        });
    }
    startScreenShare(sourceId) {
        let screen = null;
        let oid = null;
        return __classPrivateFieldGet(this, _rtc).startScreenShare(sourceId).then((stream) => {
            screen = stream;
            return VoxeetApi_1.default.screen
                .start({
                conferenceId: __classPrivateFieldGet(this, _conferenceId),
            })
                .then((r) => {
                if (!r.data || !r.data.description) {
                    throw new Error('Empty server response for start audio');
                }
                oid = r.data.description.oid;
                return r.data.description;
            })
                .then((desc) => __classPrivateFieldGet(this, _sdpQueue).push(__classPrivateFieldGet(this, _rtc), __classPrivateFieldGet(this, _rtc).setRemoteSdp, __classPrivateFieldGet(this, _ownerId), desc, ''))
                .then(() => __classPrivateFieldGet(this, _rtc).addMasterScreenStream(screen))
                .then(() => __classPrivateFieldGet(this, _rtc).createAnswer(__classPrivateFieldGet(this, _ownerId), 'default', oid))
                .catch((e) => {
                this.releaseScreenShare();
                EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(e));
                throw e;
            });
        });
    }
    changeScreenShare(sourceId) {
        let oid = null;
        if (__classPrivateFieldGet(this, _rtc)) {
            return __classPrivateFieldGet(this, _rtc).changeScreenShare(sourceId)
                .then(() => VoxeetApi_1.default.conferences.renegociate({
                conferenceId: __classPrivateFieldGet(this, _conferenceId),
            }))
                .then((r) => {
                if (!r.data || !r.data.description) {
                    throw new Error('Empty server response');
                }
                oid = r.data.description.oid;
                return r.data.description;
            })
                .then((desc) => __classPrivateFieldGet(this, _sdpQueue).push(__classPrivateFieldGet(this, _rtc), __classPrivateFieldGet(this, _rtc).setRemoteSdp, __classPrivateFieldGet(this, _ownerId), desc, ''))
                .then(() => __classPrivateFieldGet(this, _rtc).createAnswer(__classPrivateFieldGet(this, _ownerId), 'default', oid))
                .catch((e) => {
                logging_1.default.error(e);
                EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(e));
                throw e;
            });
        }
        return Promise.reject(Exceptions_1.ConferenceUninitializedError());
    }
    stopScreenShareLocally() {
        return this.checkInitialized().then(() => __classPrivateFieldGet(this, _rtc).stopScreenShare());
    }
    releaseScreenShare() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.checkInitialized();
                __classPrivateFieldGet(this, _rtc).releaseScreenShare();
            }
            catch (e) {
                throw e;
            }
        });
    }
    stopScreenShare() {
        let oid = null;
        return this.checkInitialized()
            .then(() => __classPrivateFieldGet(this, _rtc).stopScreenShare())
            .then(() => {
            if (!__classPrivateFieldGet(this, _isLeaving)) {
                // Avoid sending a stop after a conference leave, for the server
                return VoxeetApi_1.default.screen
                    .stop({ conferenceId: __classPrivateFieldGet(this, _conferenceId) })
                    .then((r) => {
                    if (!r.data || !r.data.description) {
                        throw new Error('Empty server response');
                    }
                    oid = r.data.description.oid;
                    return r.data.description;
                })
                    .then((desc) => __classPrivateFieldGet(this, _sdpQueue).push(__classPrivateFieldGet(this, _rtc), __classPrivateFieldGet(this, _rtc).setRemoteSdp, __classPrivateFieldGet(this, _ownerId), desc, ''))
                    .then(() => __classPrivateFieldGet(this, _rtc).createAnswer(__classPrivateFieldGet(this, _ownerId), 'default', oid))
                    .catch((e) => {
                    EventBusInstance_1.default.send(events_1.Events.ConferenceGlobalError.fromData(e));
                    throw e;
                });
            }
        });
    }
    meanOpinionScore() {
        //TODO: reduce, set initial value, check if this_statsBuffer is defined
        const avgPckLost = __classPrivateFieldGet(this, _statsBuffer).map((s) => s.packetLost).reduce((a, b) => a + b) / __classPrivateFieldGet(this, _statsBuffer).length;
        return Math.max(1, Math.ceil(5 - (avgPckLost * 5) / 20));
    }
    leave({ leaveRoom = true, reason = 'hangUp', keepAlive = false } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: to be fixed (async issue while leaving)
            //
            // if (participant && participant.id) {
            //   let user = this.#participants.get(participant.id);
            //   if (user) {
            //     const data: ParticipantUpdatedData = {
            //       user_id: participant.id,
            //       audio: false,
            //       audioReceivingStopped: false,
            //       participantType: user.type,
            //       status: 'LEFT'
            //     };
            //
            //     const event: ParticipantUpdated = ParticipantUpdated.fromData(data);
            //     eventBus.send(event);
            //   }
            // }
            if (__classPrivateFieldGet(this, _sdpQueue)) {
                __classPrivateFieldGet(this, _sdpQueue).stop();
            }
            __classPrivateFieldSet(this, _isLeaving, true);
            let leavePromise = Promise.resolve();
            let stateDump = null;
            if (keepAlive) {
                return VoxeetApi_1.default.conferences.leave({
                    conferenceId: __classPrivateFieldGet(this, _conferenceId),
                    keepAlive,
                    data: { reason },
                });
            }
            // close session
            if (leaveRoom && __classPrivateFieldGet(this, _conferenceId) != null) {
                leavePromise = VoxeetApi_1.default.conferences
                    .leave({ conferenceId: __classPrivateFieldGet(this, _conferenceId), data: { reason } })
                    .catch((e) => logging_1.default.info(e));
            }
            try {
                stateDump = yield __classPrivateFieldGet(this, _rtc).createStateDump({ liteMode: true });
            }
            catch (e) {
                logging_1.default.info(e);
            }
            return leavePromise.then((res) => __awaiter(this, void 0, void 0, function* () {
                yield this.releaseRtc();
                if (stateDump) {
                    EventBusInstance_1.default.send(events_1.Events.ConferenceLeft.fromData(stateDump));
                }
                else {
                    EventBusInstance_1.default.send(new events_1.Events.ConferenceLeft());
                }
                __classPrivateFieldSet(this, _maxVideoForwarding, undefined);
                __classPrivateFieldSet(this, _isLeaving, false);
                logging_1.default.debug('Leave conference', this);
                return Promise.resolve(res);
            }));
        });
    }
    releaseRtc() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _rtc)) {
                yield __classPrivateFieldGet(this, _rtc).release();
                __classPrivateFieldGet(this, _rtc).removeAllListeners();
            }
            __classPrivateFieldSet(this, _rtc, null);
        });
    }
    kick(peerId) {
        return this.checkInitialized()
            .then(() => VoxeetApi_1.default.conferences.kick({
            conferenceId: __classPrivateFieldGet(this, _conferenceId),
            peerId,
        }))
            .catch((e) => {
            throw e;
        });
    }
    onKicked() {
        EventBusInstance_1.default.send(new events_1.Events.ConferenceLeft());
        this.releaseRtc();
    }
    checkInitialized() {
        return new Promise((resolve, reject) => {
            if (!__classPrivateFieldGet(this, _rtc)) {
                reject(Exceptions_1.ConferenceUninitializedError());
            }
            resolve(true);
        });
    }
}
_conferenceService = new WeakMap(), _alias = new WeakMap(), _conferenceId = new WeakMap(), _ownerId = new WeakMap(), _own = new WeakMap(), _options = new WeakMap(), _participants = new WeakMap(), _forwardedParticipants = new WeakMap(), _maxVideoForwarding = new WeakMap(), _localStateMute = new WeakMap(), _isLeaving = new WeakMap(), _listenOnly = new WeakMap(), _statsBuffer = new WeakMap(), _masterStatus = new WeakMap(), _processCallback = new WeakMap(), _remoteOffers = new WeakMap(), _rtc = new WeakMap(), _sharedStreams = new WeakMap(), _sdpQueue = new WeakMap();
exports.default = ConferenceManager;
